import { useState } from "react"
import { getSetFromLocalStorage } from "../../../lib/services/helpers/getSetFromLocalStorage";
import { useForm } from "react-hook-form";
import { useRouter } from "next/router";

export const useSampleInterest = () => {
    const [showEmailModal,setShowEmailModal] = useState(false);
    const [message, setMessage] = useState('');
    const [bSnackbarVisible, setTriggerShowSnackbar] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const router = useRouter();
    
    const {
      register,
      handleSubmit,
      formState: { errors },
      clearErrors,
      reset
  } = useForm({
      defaultValues: {
          name: '',
          email: '',
          phoneNo: '',
          pincode: '',
          address: ''
        }
  });
    const handleSnackClose = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
    
        setTriggerShowSnackbar(false);
    };

    const handleShareInterest = async (data:any) => {
        const hashKey = getSetFromLocalStorage('shareInterestHash')
        const orderresponse = await fetch("/api/submitSamplingInterest", {
            method: "POST",
            body: JSON.stringify({ hashKey, email: data?.email,address: data?.address,pincode: data?.pincode, name: data?.name, phoneNo: data?.phoneNo, sku: data?.sku, campaign: data?.campaignName }),
            headers: {
              "Content-Type": "application/json",
            },
          });
          const resp = await orderresponse.json();
        
          if (!orderresponse.ok) {
            return resp;
          }
          if(resp?.detail?.success){
            setTriggerShowSnackbar(true)
            setShowEmailModal(false);
            setSuccessMessage(true);
            setMessage(resp?.detail?.message);
            reset();
            router.push('/thank-you-unlock-your-complimentary-ritual');
        } else {
            setTriggerShowSnackbar(true)
            setShowEmailModal(false);
            setMessage(resp?.detail?.message);
            setSuccessMessage(false);
          }
        
          return resp;
    }
    const handleEmailClose = () => {
        setShowEmailModal(false);
        clearErrors()
        reset()
    }
    return {
        showEmailModal,
        bSnackbarVisible,
        message,
        successMessage,
        setShowEmailModal,
        handleEmailClose,
        handleShareInterest,
        handleSnackClose,
        register,
        handleSubmit,
        errors
    }
}